function extractMessageFromJsonString(value: string): string | undefined {
  const trimmed = value.trim()
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
    return undefined
  }

  try {
    const parsed = JSON.parse(trimmed) as { message?: unknown; error?: unknown }
    if (typeof parsed.message === 'string' && parsed.message.trim()) {
      return parsed.message.trim()
    }
    if (typeof parsed.error === 'string' && parsed.error.trim()) {
      return extractMessageFromJsonString(parsed.error) ?? parsed.error.trim()
    }
  } catch {
    // Not JSON — use the raw string below.
  }

  return undefined
}

function extractMessage(value: unknown): string | undefined {
  if (value == null) {
    return undefined
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) {
      return undefined
    }
    return extractMessageFromJsonString(trimmed) ?? trimmed
  }

  if (value instanceof Error) {
    return extractMessage(value.message)
  }

  if (typeof value === 'object') {
    const record = value as Record<string, unknown>
    return (
      extractMessage(record.message) ??
      extractMessage(record.error) ??
      extractMessage(record.Message) ??
      extractMessage(record.data) ??
      extractMessage(record.payload)
    )
  }

  return undefined
}

export function getDatabricksErrorMessage(error: unknown): string {
  const message = extractMessage(error)
  if (message) {
    return message
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    return error
  }

  try {
    return JSON.stringify(error)
  } catch {
    return 'Unknown error'
  }
}
